import { render } from "./ModalRechazar.vue?vue&type=template&id=34b5946e"
import script from "./ModalRechazar.vue?vue&type=script&lang=js"
export * from "./ModalRechazar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/cn-chatbot-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__